import { Component, OnInit } from "@angular/core";
import { ProfessionalsService } from "../../services/professionals.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { Urls } from "../../../../config/urls.config";
import { AuthService } from "src/app/services/auth.service";
import { LoggerService } from "../../../../shared/logger.service";
import Swal from "sweetalert2";
import { ErrorHandlerService } from "src/app/shared/error-handler.service";

@Component({
  selector: "app-professionals-list",
  templateUrl: "./professionals-list.component.html",
  styleUrls: ["./professionals-list.component.css"],
})
export class ProfessionalsListComponent implements OnInit {
  professionalsHeaders = ["Id", "Foto", "Nome", "Cargo", "Permissão"];
  professionalsData = [];
  loading: boolean = true;
  deleting: boolean = false;

  userRole: string[] = [];
  isAdmin: boolean = false;
  isSupervisor: boolean = false;
  isManager: boolean = false;
  isUser: boolean = false;

  constructor(
    private professionalService: ProfessionalsService,
    private toast: ToastrService,
    private authService: AuthService,
    public router: Router,
    private errorHandlerService: ErrorHandlerService,
    private logger: LoggerService
  ) {}

  ngOnInit(): void {
    this.getUserRoles();
    this.loadProfessionalsData();
  }

  private getUserRoles(): void {
    this.authService.getUserRoles().forEach((role) => {
      this.logger.debug("User role", role.name);
      switch (role.name) {
        case "ROLE_ADMIN":
          this.isAdmin = true;
          break;
        case "ROLE_MANAGER":
          this.isManager = true;
          break;
        case "ROLE_SUPERVISOR":
          this.isSupervisor = true;
          break;
        case "ROLE_USER":
          this.isUser = true;
          break;
        default:
          this.isUser = true;
      }
    });
  }

  private loadProfessionalsData(): void {
    this.professionalService.findAllByContractType("Professional").subscribe({
      next: (professionals) => {
        if (professionals != null) {
          professionals.forEach((response) => {
            response.picture = response.picture == null ? Urls.getDefaultPictureS3() : response.picture;
            let accessType =
              response.accessType == "Manager" ? "Gerente" : response.accessType == "User" ? "Usuário" : "Supervisor";
            const professional = [
              response.id,
              response.picture,
              response.name,
              response.responsibilityName,
              accessType,
            ];
            this.professionalsData.push(professional);
          });
        }
        this.loading = false;
      },
      error: (ex) => {
        this._handleErrors(ex);
        this.loading = false;
      },
    });
  }

  // Métodos para emitir os eventos de ação
  onEdit(professional: any) {
    this.logger.debug("Editing professional", professional);
    const id = professional[0];
    this.router.navigate(["/professionals/edit/", id]);
  }

  public onDelete(row: any): void {
    const id = row[0];
    const name = row[2];
    Swal.fire({
      title: "Desativar Profissional Autônomo",
      html: `
        <div class="delete-dialog-content">
          <div class="delete-icon-wrapper">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="#f44336"/>
            </svg>
          </div>
          <p class="delete-dialog-title">Tem certeza que deseja desativar este profissional autônomo?</p>
          <div class="delete-dialog-employee-info">
            <strong>${name}</strong>
          </div>
          <p class="delete-dialog-warning">Esta ação não pode ser desfeita. O profissional será desativado e não poderá mais acessar o sistema.</p>
        </div>
      `,
      icon: "warning",
      iconColor: "#f44336",
      showCancelButton: true,
      confirmButtonText: "Sim, desativar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#f44336",
      cancelButtonColor: "#6c757d",
      buttonsStyling: true,
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        popup: "delete-dialog-popup",
        title: "delete-dialog-swal-title",
        htmlContainer: "delete-dialog-html-container",
        confirmButton: "delete-dialog-confirm-button",
        cancelButton: "delete-dialog-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleting = true;
        this.professionalService.delete(id).subscribe({
          next: () => {
            Swal.fire({
              title: "Desativado!",
              text: `O profissional autônomo ${name} foi desativado com sucesso.`,
              icon: "success",
              confirmButtonColor: "#4caf50",
              confirmButtonText: "OK",
              timer: 3000,
              timerProgressBar: true,
            });
            this.deleting = false;
            window.location.reload();
          },
          error: (error) => {
            this.deleting = false;
            Swal.fire({
              title: "Erro!",
              text: "Não foi possível desativar o profissional autônomo. Tente novamente.",
              icon: "error",
              confirmButtonColor: "#f44336",
              confirmButtonText: "OK",
            });
            this.errorHandlerService.handle(error, "Erro ao deletar profissional autônomo(a) selecionado(a).");
          },
        });
      }
    });
  }

  onView(row: any) {
    this.logger.debug("Viewing professional", row);
  }

  private _handleErrors(ex: any): void {
    if (ex.error.errors) {
      ex.error.errors.forEach((element) => {
        this.toast.error(element.message);
      });
    } else {
      this.toast.error(ex.error.message);
    }
  }
}
